import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { sunrisePrimitives, theme } from '@vfit/shared/themes';
import { IInputsForSC } from '../../../../inputs.models';

const variants = {
  button: {
    animated: ({ error, disabled }: IInputsForSC) => css`
      border-color: ${!error ? theme.colors.border.default : theme.colors.interactive.hover};
      border-radius: ${theme.radius.sm};
      height: 60px;
      padding: 18px 56px 18px 20px;

      &.valued + span {
        font-size: ${theme.typography.fontSize.body3};
        line-height: ${theme.typography.lineHeight.body3};
        font-weight: ${theme.typography.fontWeight.regular};

        color: ${!disabled ? theme.colors.text.primary : theme.colors.text.secondary};
        transform: translate3d(0, -27px, 0);
      }
    `,
    'mva:animated': ({ error, disabled }: IInputsForSC) => css`
      border-color: ${!error ? theme.colors.border.default : theme.colors.interactive.hover};
      border-radius: ${theme.radius.md};
      ${error ? `box-shadow: 0 0 0 1px ${theme.colors.brand.primaryHover};` : ''}
      height: 44px;
      padding: 9px 54px 9px 15px;

      &:focus {
        border-color: ${sunrisePrimitives.cyanLight};
        box-shadow: 0 0 0 1px ${sunrisePrimitives.cyanLight};
      }

      &.valued + span {
        font-size: ${theme.typography.fontSize.body3};
        line-height: ${theme.typography.lineHeight.body3};
        font-weight: ${theme.typography.fontWeight.regular};
        color: ${!disabled ? theme.colors.text.primary : theme.colors.text.secondary};
        transform: translate3d(0, -19px, 0);
      }
    `,
    'mva:static': ({ error }: IInputsForSC) => css`
      border-color: ${!error ? theme.colors.border.default : theme.colors.interactive.hover};
      border-radius: ${theme.radius.sm};
      ${error ? `box-shadow: 0 0 0 1px ${theme.colors.interactive.hover};` : ''}
      height: 44px;
      padding: 9px 54px 9px 15px;

      &:focus {
        border-color: ${sunrisePrimitives.cyanLight};
        box-shadow: 0 0 0 1px ${sunrisePrimitives.cyanLight};
      }
    `,
  },
};

export const Button = styled.button<IInputsForSC>`
  font-size: ${theme.typography.fontSize.body1};
  line-height: ${theme.typography.lineHeight.body1};
  font-weight: ${theme.typography.fontWeight.regular};
  border-width: 1px;
  border-style: solid;
  color: ${({ disabled }) => (!disabled ? theme.colors.text.primary : theme.colors.text.secondary)};
  cursor: ${({ disabled }) => (!disabled ? 'pointer' : 'not-allowed')};
  line-height: 1;
  outline: 0; // TODO This is a bad practice
  text-align: left;
  transition: border-color 0.3s ease;
  width: 100%;

  &::file-selector-button {
    display: none;
  }

  ${({ bg }) => (bg ? `background-color: ${bg};` : '')};
  ${(props: any) => (props.variant ? (variants.button as any)[props.variant](props) : '')}
`;

export const Placeholder = styled.span`
  color: ${theme.colors.text.secondary};
  pointer-events: none;
  transition: all 0.3s ease;
`;

